import CalendarPage from '../pages/calendar';
import ClientDashboardPage from '../pages/client_dashboard/dashboard';
import LeadManagementPage from '../pages/lead_management';
import { protectedRoute } from './';
import SalesAndMarketingPage from '../pages/sales_and_marketing';
import TasksAndFilesPage from '../pages/tasks_and_files';
import TeamSpacePage from '../pages/team_space';

export const AdminAndClientAccessRoutes = [
    {
        path: 'dashboard',
        Component: () => protectedRoute(<ClientDashboardPage />, ['client', 'companyManager', 'organizationAdmin', 'organizationOwner'])
    },
    {
        path: 'task-files',
        Component: () => protectedRoute(<TasksAndFilesPage />, ['client', 'companyManager', 'organizationAdmin', 'organizationOwner'])
    },
    {
        path: 'lead-management',
        Component: () => protectedRoute(<LeadManagementPage />, ['client', 'companyManager', 'organizationAdmin', 'organizationOwner'])
    },
    {
        path: 'sales-marketing',
        Component: () => protectedRoute(<SalesAndMarketingPage />, ['client', 'companyManager', 'organizationAdmin', 'organizationOwner'])
    },
    {
        path: 'team-space',
        Component: () => protectedRoute(<TeamSpacePage />, ['client', 'companyManager', 'organizationAdmin', 'organizationOwner'])
    },
    {
        path: 'calendar',
        Component: () => protectedRoute(<CalendarPage />, ['client', 'companyManager', 'organizationAdmin', 'organizationOwner'])
    }
];